import { v4 } from 'uuid';
import { DEV } from 'esm-env';
export let uuid;
if (typeof crypto !== 'undefined') {
    uuid = () => crypto.randomUUID();
}
else {
    uuid = v4;
}
export const encodeBase64 = (value) => btoa(JSON.stringify(value)).replace(/=+$/, '');
export const decodeBase64 = (str) => JSON.parse(atob(str));
export function toCamel(s) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return s.replace(/(_[a-z])/gi, ($1) => $1[1].toUpperCase());
}
export function daysFromNow(numDays) {
    const date = new Date();
    date.setDate(date.getDate() + numDays);
    return date;
}
export function hoursFromNow(numHours) {
    const date = new Date();
    date.setHours(date.getHours() + numHours);
    return date;
}
export function redirect(url) {
    return new Response(null, {
        status: 302,
        headers: {
            location: url,
            'cache-control': 'no-cache',
        },
    });
}
export function expect(value, message) {
    if (value === null || value === undefined) {
        throw new Error(message);
    }
    return value;
}
export function assert(predicate, message) {
    if (!predicate) {
        throw new Error(message);
    }
}
export const getLoginHint = (url, headers, ignoreSignup = true) => {
    const hint = url.searchParams.get('login_hint') ??
        url.searchParams.get('loginHint') ??
        headers?.get('x-login-hint') ??
        undefined;
    if (ignoreSignup) {
        return hint !== 'signup' ? hint : undefined;
    }
    return hint;
};
export const getLoginHintFromEvent = (event, ignoreSignup = true) => getLoginHint(event.url, event.request.headers, ignoreSignup);
export const tryParseUrl = (url) => {
    if (!url) {
        return;
    }
    try {
        return new URL(url);
    }
    catch (e) {
        // do nothing
    }
};
export const getTargetUrl = (target, event, config) => {
    const targetUrl = tryParseUrl(target);
    const isValidTargetUrl = targetUrl &&
        // If is production, verify it's the same origin as the incoming request
        (targetUrl?.origin === event.url.origin ||
            // If we're in dev mode or testing, verify that it's a valid localhost URL
            (DEV && targetUrl?.origin.match(/^(http:\/\/localhost:\d+)$/)));
    // If it was not a valid origin, or there was no target, redirect to the the
    // standard origin (preventing phishing redirect attacks)
    const resultUrl = isValidTargetUrl ? targetUrl : new URL(event.url.origin + config.base);
    const loginHint = getLoginHintFromEvent(event);
    if (loginHint) {
        resultUrl.searchParams.set('login_hint', loginHint);
    }
    return resultUrl.toString();
};
export const generateSecureKey = (length = 32) => {
    const array = new Uint8Array(length / 2);
    crypto.getRandomValues(array);
    return Array.from(array, (byte) => ('0' + byte.toString(16)).slice(-2)).join('');
};
